// extracted by mini-css-extract-plugin
export default {"outerbody":"Bg_outerbody__ZGroD","stars":"Bg_stars__yv76B","star":"Bg_star__w0CMi","fall":"Bg_fall__HpFdf","tail-fade":"Bg_tail-fade__kgPtA","blink":"Bg_blink__uNrjb"};